"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DataLinks;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _actions = require("../../actions");

var _mapping = require("../../reducers/mapping");

var _helpers = require("../../../helpers");

var _reactRouterDom = require("react-router-dom");

var _DataLinksCreativeBriefsModal = _interopRequireDefault(require("./DataLinksCreativeBriefsModal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DataPages = {
  DATA_EXPLORER: 'data-explorer',
  AUDIENCE_PROFILING: 'audience-profiling'
};

function DataLinks(_ref) {
  var selectedPersonas = _ref.selectedPersonas,
      segmentType = _ref.segmentType,
      currentUniverse = _ref.currentUniverse,
      currentDataPage = _ref.currentDataPage;
  var dispatch = (0, _reactRedux.useDispatch)();
  var universeId = (0, _reactRedux.useSelector)(function (state) {
    return state.universes.currentUniverse;
  });
  var personaIdsArray = selectedPersonas.map(function (persona) {
    return persona.id;
  });
  var personaIds = personaIdsArray.join(',');
  var creativeBriefsDisabled = segmentType !== 'segments';
  (0, _react.useEffect)(function () {
    if (segmentType === 'segments') {
      dispatch((0, _actions.getPersonaInsights)(personaIds));
    } else {
      dispatch((0, _actions.getCommunityInsights)(personaIds));
    }
  }, [dispatch, personaIds, segmentType]);

  var _useSelector = (0, _reactRedux.useSelector)(_mapping.mappingQueryComposer),
      mappingQueryString = _useSelector[0],
      isFetchingInsights = _useSelector[1];

  var mappingUrl = (0, _helpers.generateMappingURL)(currentUniverse, mappingQueryString);
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
    text: "View In" // TODO: refactor class
    ,
    className: "audience-view-toggle--select"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown.Menu, null, currentDataPage === DataPages.DATA_EXPLORER ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown.Item, null, /*#__PURE__*/_react["default"].createElement(_DataLinksCreativeBriefsModal["default"], {
    selectedPersonas: selectedPersonas,
    segmentType: segmentType,
    currentDataPage: currentDataPage
  })) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown.Item, {
    disabled: creativeBriefsDisabled || !selectedPersonas.length
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "creative-briefs/message-streams?personaIds=" + personaIds + "&universeId=" + universeId,
    target: "_blank",
    className: "no-underline text"
  }, "Send selected personas to creative briefs")), !(0, _helpers.isNZHelix)() ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown.Item, {
    disabled: !selectedPersonas.length || isFetchingInsights
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: mappingUrl,
    className: "no-underline text",
    target: "_blank",
    rel: "noreferrer"
  }, "Send to Mapping")) : null));
}